module.exports = __webpack_public_path__ + "img/abacuslogo.6612ed90.png";